import { useState, useEffect } from 'react';
import type { BulkEditRow } from '@netsuite-ai/types';

interface Props {
  row: BulkEditRow;
  onSave: (id: string, fields: Record<string, string>) => void;
  onCloseModal?: () => void;
}

export function BulkEditDrawer({ row, onSave, onCloseModal }: Props) {
  const [editedFields, setEditedFields] = useState<Record<string, string>>(() =>
    Object.fromEntries(
      Object.entries(row.fields).map(([k, v]) => [k, String(v ?? '')]),
    ),
  );

  useEffect(() => {
    setEditedFields(
      Object.fromEntries(
        Object.entries(row.fields).map(([k, v]) => [k, String(v ?? '')]),
      ),
    );
  }, [row.id]);

  return (
    <div className="">
      <p className="mb-4 px-6 py-2 text-xs font-semibold tracking-wide text-neutral-500 uppercase">
        Editing · {row.id}
      </p>

      <div className="space-y-3 px-6">
        {Object.keys(editedFields).map((key) => (
          <div key={key}>
            <p className="mb-1 text-sm font-medium text-neutral-900">{key}</p>
            <input
              value={editedFields[key]}
              onChange={(e) =>
                setEditedFields((f) => ({ ...f, [key]: e.target.value }))
              }
              className="w-full rounded border border-neutral-300 px-3 py-1.5 text-sm text-neutral-900 outline-none focus:border-neutral-500"
            />
          </div>
        ))}
      </div>

      <div className="bg-ink/4 mt-5 flex gap-2 px-6 py-6">
        <button
          onClick={onCloseModal}
          className="bg-danger rounded px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            onSave(row.id, editedFields);
            onCloseModal?.();
          }}
          className="bg-ink/14 rounded border border-neutral-300 px-4 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-200"
        >
          Save changes
        </button>
      </div>
    </div>
  );
}
